import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ConditionCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ConditionCircleSVG;
